var $ = window.jQuery

$(function() {
  // 导航栏颜色
  $('#header ul li:eq(4) a').attr('class','activity');
  // hover 二维码显示隐藏
  $('.doctor-content ul:nth-of-type(3) .icon-code').hover(function() {
    $('.doctor-content ul:nth-of-type(3) .icon-code').css('color','#27C6C6');
    $('.doctor-content ul:nth-of-type(3) li:last-of-type').css('display','block');
  },function() {
    $('.doctor-content ul:nth-of-type(3) .icon-code').css('color','#C7C7C7');
    $('.doctor-content ul:nth-of-type(3) li:last-of-type').css('display','none');
  })
  $('.doctor-content ul:nth-of-type(4) .icon-code').hover(function() {
    $('.doctor-content ul:nth-of-type(4) .icon-code').css('color','#27C6C6');
    $('.doctor-content ul:nth-of-type(4) li:last-of-type').css('display','block');
  },function() {
    $('.doctor-content ul:nth-of-type(4) .icon-code').css('color','#C7C7C7');
    $('.doctor-content ul:nth-of-type(4) li:last-of-type').css('display','none');
  })

  // 获取统计量
  function loadDoctorAppDownloadStatics() {
    $.ajax({
      url:'http://www.sq580.com/v3/application',
      type:'post',
      dataType:'json',
      data:{
        type:'doctor'
      },
      success:function(result) {
        if (!result.err) {
					if (result.data && result.data > 0) {
            $('.word span').html(commafy(result.data))
					}
			  }
      },
      error:function() {
        console.log("下载量加载错误！");
      }
    })
  }

  // 统计下载量数量显示 格式
  function commafy(num){
    if((num+"").trim()==""){
     return"";
    }
    if(isNaN(num)){
     return"";
    }
    num = num+"";
    if(/^.*\..*$/.test(num)){
     varpointIndex =num.lastIndexOf(".");
     varintPart = num.substring(0,pointIndex);
     varpointPart =num.substring(pointIndex+1,num.length);
     intPart = intPart +"";
      var re =/(-?\d+)(\d{3})/
      while(re.test(intPart)){
       intPart =intPart.replace(re,"$1,$2")
      }
     num = intPart+"."+pointPart;
    }else{
     num = num +"";
      var re =/(-?\d+)(\d{3})/
      while(re.test(num)){
       num =num.replace(re,"$1,$2")
      }
    }
    return num;
  }
  loadDoctorAppDownloadStatics();

  //医生端下载iOS端统计
  $('.download-doctor-ios').click(function(){
    statistics('loaddoctor_selfpc_ios','医生自行下载');
  });

  // 医生端下载安卓端统计
  $('.download-android').click(function(){
    statistics('loaddoctor_selfpc_android','医生自行下载')
		$.ajax({
			url : 'http://www.sq580.com/v3/application/add',
			type : 'POST',
			data: {
				type: 'doctor'
			},
			contentType:"application/x-www-form-urlencoded; charset=UTF-8",
			beforeSend: function(){},
			success : function(result) {
				if (!result.err) {
					loadDoctorAppDownloadStatics()
				}
			},
			error:function(XMLHttpRequest, textStatus, errorThrown){}
		})
  });

  // 随访 下载安卓端统计
  $('.download-followup-android').click(function() {
    statistics('loadfollowup_self_android','自行下载随访应用');
  })

  // 随访 下载ios端统计
  $('.download-followup-ios').click(function(){
    statistics('loadfollowup_self_ios','自行下载随访应用');
  });


})
